export default __webpack_public_path__ + "static/media/languageSelected.c7852d49.svg";